module.exports = __webpack_public_path__ + "img/iknow.4cc31f22.png";